import { useDispatch, useSelector } from "react-redux";
import { Appstore } from "../../redux";
import { useEffect, useState } from "react";
import { SetGlobalCrisis } from "../../redux/catalogs/states";
import { getGlobalCrisis } from "../../Services/GlobalCrisis";

const UseGlobalCrisislList = () => {
  const [isFetching, setIsFetching] = useState(true)

  const dispatch = useDispatch();
  const contentGlobalCrisisData = useSelector((state: Appstore) => state.globalCrisis);

  const resetGlobalCrisis = () => {
    setIsFetching(true)
  }
  useEffect(() => {
      if (contentGlobalCrisisData.length) {
        setIsFetching(false)
        return
      }
      if (!isFetching) {
        return
      }

      getGlobalCrisis()
      .then((response) => {
        dispatch(SetGlobalCrisis(response))
        if (!response.length) {
          console.error('No global crisis found. Please check the data source.')
        }
      })
      .catch((error) => console.error(error))
      .finally(() => setIsFetching(false))
  }, [isFetching]);

  return {contentGlobalCrisisData, isFetching,resetGlobalCrisis};
};

export {UseGlobalCrisislList}
